import { Col, Modal, Row } from 'antd';
import { Channels } from '../../../common/channelsEnum';
import {
  DeliveryOptions,
  InappWebDeliveryOptions,
  Notification
} from '../../../../interfaces/backend/Notifications';
import ChannelDeliveryOptions from './ChannelDeliveryOptions';
import ChannelOptionsConfirm from './ChannelOptionsConfirm';
import { useState } from 'react';
import { getChannelReadableName } from '../../../../utils/readable';

export interface ChannelOptionsParams {
  channel: Channels;
  notification: Notification;
  updateNotification: (notification: Notification) => void;
  close: () => void;
  isOpen: boolean;
}

const ChannelOptionsModal: React.FC<ChannelOptionsParams> = (props) => {
  const [updatedNotification, setUpdatedNotification] = useState<Notification>({
    ...props.notification
  });

  const onDeliveryOptionsChange = (
    options: DeliveryOptions | InappWebDeliveryOptions,
    channel: Channels
  ) => {
    const newOptions = { ...props.notification.options, [channel]: options };
    const newNotification = {
      ...props.notification,
      options: newOptions
    };
    setUpdatedNotification(newNotification);
  };

  return (
    <Modal
      destroyOnClose={true}
      title={`${getChannelReadableName(props.channel)} Delivery Options`}
      open={props.isOpen}
      okText={
        !props.notification.channels.includes(props.channel) ? 'Enable' : 'Save'
      }
      onOk={async () => {
        const newNotification = {
          ...updatedNotification,
          channels: props.notification.channels.includes(props.channel)
            ? props.notification.channels
            : [...props.notification.channels, props.channel]
        };
        await props.updateNotification(newNotification);
        props.close();
      }}
      onCancel={() => {
        props.close();
      }}
    >
      <Row>
        <Col span={24}>
          <Row>
            <ChannelDeliveryOptions
              channel={props.channel}
              deliveryOptions={updatedNotification.options?.[props.channel]}
              onDeliveryOptionsChange={onDeliveryOptionsChange}
            />
          </Row>
        </Col>

        <ChannelOptionsConfirm
          channel={props.channel}
          notification={props.notification}
          updatedNotification={updatedNotification}
        />
      </Row>
    </Modal>
  );
};

export default ChannelOptionsModal;
